import { Lightning } from '@lightningjs/sdk';
import Carousel, {
  CarouselTemplateSpec,
} from 'components/common/carousels/Carousel';
import { VideoLaneItem } from 'services/cwData';

export interface WatchHistoryCarouselTemplateSpec extends CarouselTemplateSpec {
  laneItems: VideoLaneItem[];
}

export class WatchHistoryCarousel
  extends Carousel<WatchHistoryCarouselTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<WatchHistoryCarouselTemplateSpec>
{
  override readonly _imageKey = 'thumbnail';
  override readonly _expandedImageKey = null;
}
